import React from 'react';
import {
  Container,
  Flex,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import type { NextPage } from 'next';
import Layout from '@/components/Layout';

const COCData = [
  {
    id: 1,
    label:
      'Always respect - IVC Association, reputation, goodwill and other business assets when using this site',
  },
  {
    id: 2,
    label:
      'Refrain from making any statements or publish any material that would be insulting, threatening, libellous, obscene, offensive to religious, political or ethical beliefs, discriminating or racially oriented, or otherwise infringing any applicable legislation or third party rights',
  },
  {
    id: 3,
    label:
      'Refrain from making any statements that would be disrespectful,misrepresenting, or otherwise harmful to IVCA, or any third party',
  },
  {
    id: 4,
    label:
      'Ensure that any software, databases, or other files that you post on the site are free from viruses, corrupt files, defects or any other sources of harm that can impair the operation of this site or any other systems',
  },
  {
    id: 5,
    label: 'Refrain from using the site for purposes of commercial advertising',
  },
];

const TAndC: NextPage = () => (
  <Layout
    title="Terms & Conditions"
    description="In viewing this site, you agree to the 'Terms and Conditions', all applicable laws and regulations, and agree that you are responsible for compliance with any applicable local laws.

  These 'Terms and Conditions' may be occasionally updated, so please refer back to them in the future. In using this site, you agree to be bound by the current version of these Terms"
    url="tc"
  >
    <Flex
      flexDir="column"
      backgroundImage="linear-gradient(#F7F7FB 0 25%, #E2E2E2 25% 100%)"
      pb="50px"
    >
      <Text variant="headingText" textAlign="center" py="50px">
        Terms & Conditions
      </Text>
      <Container maxW="1325px">
        <Flex
          flexDir="column"
          bg="white"
          py="80px"
          px="50px"
          boxShadow="lg"
          borderRadius="8px"
        >
          <Text
            variant="headingText"
            fontWeight="500"
            fontSize="1.3rem"
            textAlign="justify"
          >
            In viewing this site, you agree to the &apos;Terms and
            Conditions&apos;, all applicable laws and regulations, and agree
            that you are responsible for compliance with any applicable local
            laws.
          </Text>
          <Text variant="aboutText" pt="15px" textAlign="justify">
            These &apos;Terms and Conditions&apos; may be occasionally updated,
            so please refer back to them in the future. In using this site, you
            agree to be bound by the current version of these Terms.
          </Text>
          <Text variant="aboutText" pt="15px" textAlign="justify">
            These Terms and Conditions govern your use of IVCA&apos;s website,
            services, and program. By accessing, using, or registering for our
            services, you agree to be bound by these Terms.
          </Text>
          <Text
            variant="headingText"
            fontWeight="semibold"
            fontSize="1.3rem"
            pt="60px"
          >
            Subject
          </Text>
          <Text variant="aboutText" pt="15px" textAlign="justify">
            This web platform is the property of IVCA, registered under: Indian
            Private Equity and Venture Capital Association (IVCA), - IVC
            Association, Office No. 7 and 13, 1st Floor, Innov8, Old Fort Saket,
            District Centre, South Delhi, New Delhi - 110017.
          </Text>
          <Text
            variant="headingText"
            fontWeight="semibold"
            fontSize="1.3rem"
            pt="60px"
          >
            Purpose of this Site
          </Text>
          <Text variant="aboutText" pt="15px" textAlign="justify">
            This site aims to inform you about the activities, event/delegate
            fees, membership fees, advertising revenue and sale of directory and
            other merchandise..
          </Text>
          <Text
            variant="headingText"
            fontWeight="semibold"
            fontSize="1.3rem"
            pt="60px"
          >
            Use of this Site
          </Text>
          <Text variant="aboutText" pt="15px" textAlign="justify">
            You are permitted to use this site for your own personal use and to
            print and download material from this site provided that you do not
            modify any content without IVCA&apos;s consent. You are also free to
            bookmark and share links directing others to content on this site.
            Material on this site must not otherwise be reproduced or
            republished, either online or offline, without IVCA&apos;s
            permission.
          </Text>
          <Flex flexDir="column">
            <Text
              variant="headingText"
              fontWeight="semibold"
              fontSize="1.3rem"
              pt="60px"
            >
              Code of Conduct
            </Text>
            <Text variant="aboutText" pt="15px" textAlign="justify">
              IVCA values and encourages freedom of expression. To maintain a
              right balance between such freedom of expression, and potential
              abuses of this site, you agree to:
            </Text>
            <UnorderedList pl="20px">
              {COCData.map((cocInfo) => (
                <ListItem
                  fontSize="1.15rem"
                  color="text.darkHead"
                  key={cocInfo.id}
                >
                  {cocInfo.label}
                </ListItem>
              ))}
            </UnorderedList>
            <Text
              fontSize="1.15rem"
              color="text.darkHead"
              pt="15px"
              textAlign="justify"
            >
              Please note that IVCA takes the liberty to remove all posts that
              violate the “Code of Conduct” without prior notification.
            </Text>
          </Flex>

          <Flex flexDir="column">
            <Text
              pt="60px"
              pb="10px"
              variant="headingText"
              fontWeight="semibold"
              fontSize="1.3rem"
            >
              Data Protection
            </Text>
            <UnorderedList pl="20px">
              <ListItem
                fontSize="1.15rem"
                color="text.darkHead"
                textAlign="justify"
              >
                IVCA requires you to provide a degree of personal data when
                registering to this site. You agree that IVCA may use your
                personal data collected with this site for purposes of inviting
                you to participate in new services and in events organised,
                sponsored, or attended by IVCA.
              </ListItem>
              <ListItem
                fontSize="1.15rem"
                color="text.darkHead"
                textAlign="justify"
              >
                IVCA reserves the right to collect and use data relating to
                visits to this site for monitoring and statistical purposes, and
                to use cookies for enhancing the usability of this site.
              </ListItem>
              <ListItem
                fontSize="1.15rem"
                color="text.darkHead"
                textAlign="justify"
              >
                Except for the communication of personal data required for the
                above purposes, IVCA will keep your personal data confidential.
                IVCA will not allow third-parties to use such personal data for
                their direct marketing purposes.
              </ListItem>{' '}
              <ListItem
                fontSize="1.15rem"
                color="text.darkHead"
                textAlign="justify"
              >
                You may contact IVCA to exercise your access rights and to
                answer any questions relating to the use of your data, by
                contacting Aakriti Bamniyal at aakriti@ivca.in
              </ListItem>{' '}
            </UnorderedList>
          </Flex>
          <Flex flexDir="column">
            <Text
              pt="60px"
              pb="10px"
              variant="headingText"
              fontWeight="semibold"
              fontSize="1.3rem"
            >
              Copyright
            </Text>
            <UnorderedList pl="20px">
              <ListItem fontSize="1.15rem" color="text.darkHead">
                On the Site The copyright on this site belongs to IVCA. You are
                not authorised to reproduce, modify or make any part of this
                site publicly available without IVCA permission.
              </ListItem>
              <ListItem fontSize="1.15rem" color="text.darkHead">
                On User-Generated Content You are responsible for the content
                that you post on this site. Ownership of the content belongs to
                you. IVCA does not claim any rights on such content.
              </ListItem>
            </UnorderedList>
          </Flex>
          <Flex flexDir="column">
            <Text
              pt="60px"
              pb="10px"
              variant="headingText"
              fontWeight="semibold"
              fontSize="1.3rem"
            >
              Liability
            </Text>
            <UnorderedList pl="20px">
              <ListItem fontSize="1.15rem" color="text.darkHead">
                Although IVCA uses reasonable efforts to ensure the quality of
                this site, you accept that information and materials posted may
                contain inaccuracies or errors and that IVCA exclude liability
                for any such inaccuracies or errors to the fullest extent
                permitted by law.
              </ListItem>
              <ListItem fontSize="1.15rem" color="text.darkHead">
                This site may contain links to other sites, which are not
                controlled or maintained by IVCA. Please note that IVCA is not
                responsible for their content. IVCA provides those links for
                your convenience only, and the inclusion of such links does not
                imply any IVCA endorsement of these sites.
              </ListItem>
            </UnorderedList>
          </Flex>
          <Flex flexDir="column">
            <Text
              pt="60px"
              pb="10px"
              variant="headingText"
              fontWeight="semibold"
              fontSize="1.3rem"
            >
              Notifications
            </Text>
            <UnorderedList pl="20px">
              <ListItem fontSize="1.15rem" color="text.darkHead">
                IVCA will always try to handle cases of alleged illegal content
                or violations of the Terms and Conditions in a fair and balanced
                way.
              </ListItem>
              <ListItem fontSize="1.15rem" color="text.darkHead">
                When IVCA notices or is informed about alleged illegal content
                or other violations of the Terms and Conditions, IVCA reserves
                the right to immediately remove, or disable access to, such
                content.
              </ListItem>
              <ListItem fontSize="1.15rem" color="text.darkHead">
                Nothing herein can force IVCA to take down alleged illegal
                content from this site, nor prevent IVCA from taking down such
                content. You may report violations of the Terms of Use by e-mail
                to:{' '}
                <Link href="/#" color="#18acd5">
                  aakriti@ivca.in
                </Link>
              </ListItem>
            </UnorderedList>
          </Flex>
          {/*  */}
          <Flex flexDir="column">
            <Text
              pt="60px"
              pb="10px"
              variant="headingText"
              fontWeight="semibold"
              fontSize="1.3rem"
            >
              Membership
            </Text>
            <UnorderedList pl="20px">
              <ListItem fontSize="1.15rem" color="text.darkHead">
                In order to access certain services or attend specific program,
                you may be required to provide accurate, current, and complete
                information as part of the registration process. You agree to
                keep this information up to date.
              </ListItem>
              <ListItem fontSize="1.15rem" color="text.darkHead">
                Membership in IVCA is annual, with a term of 12 months unless
                agreed otherwise which will have to be renewed after the end of
                the term on the agreed upon form of payment.
              </ListItem>
              <ListItem fontSize="1.15rem" color="text.darkHead">
                Your membership will be confirmed, once IVCA receives the full
                amount of the membership fee. This fee is non-refundable,
                including upon renewal.
              </ListItem>
            </UnorderedList>
          </Flex>
          {/*  */}
          <Flex flexDir="column">
            <Text
              pt="60px"
              pb="10px"
              variant="headingText"
              fontWeight="semibold"
              fontSize="1.3rem"
            >
              Program Participation:
            </Text>
            <UnorderedList pl="20px">
              <ListItem fontSize="1.15rem" color="text.darkHead">
                IVCA shall share the communications with its members regarding
                all the relevant programs for them to attend. These programs can
                be paid or free for our members depending on the program type.
                If you are unable to attend a program after registering, a
                substitute delegate from the same company may/may not attend in
                your place depending on the program type, but the program fees
                once paid is non-refundable. The discretion to allow a
                substitute to attend the program in your place lies with the
                IVCA team.
              </ListItem>
              <ListItem fontSize="1.15rem" color="text.darkHead">
                IVCA reserves the right to change any aspect of a program
                without liability. Should a program be postponed, we will offer
                an alternative date and in case of cancellation may proceed with
                refund of the registration amount.
              </ListItem>
            </UnorderedList>
          </Flex>
          {/*  */}
          <Flex flexDir="column">
            <Text
              pt="60px"
              pb="10px"
              variant="headingText"
              fontWeight="semibold"
              fontSize="1.3rem"
            >
              Intellectual Property and Media Use:
            </Text>
            <UnorderedList pl="20px">
              <ListItem fontSize="1.15rem" color="text.darkHead">
                IVCA shall share the communications with its members regarding
                all the relevant programs for them to attend. These programs can
                be paid or free for our members depending on the program type.
                If you are unable to attend a program after registering, a
                substitute delegate from the same company may/may not attend in
                your place depending on the program type, but the program fees
                once paid is non-refundable. The discretion to allow a
                substitute to attend the program in your place lies with the
                IVCA team.
              </ListItem>
              <ListItem fontSize="1.15rem" color="text.darkHead">
                By attending an IVCA event, you grant IVCA permission to record,
                film, photograph, or capture graphics which may involve you in
                IVCA’s promotional materials. You agree that IVCA may edit and
                distribute such media globally, without any further approval or
                compensation to you.
              </ListItem>
            </UnorderedList>
          </Flex>
        </Flex>
      </Container>
    </Flex>
  </Layout>
);

export default TAndC;
